<script>
    import { client, gql } from "../GraphQL.svelte";

    import { link } from "svelte-routing";
    import { navigate } from "svelte-routing";

    import CompanyDropdown from "./form/CompanyDropdown.svelte";
    import Logo from "./Logo.svelte";
    import UserMenu from "./menu/UserMenu.svelte";
    import LoadingModal from "./LoadingModal.svelte";

    // TODO: dont tightly couple
    import ProjectDropdown from "./participaid/ProjectDropdown.svelte";

    export let product = "participaid";
    export let project;

    let request;

    function viewOtherProject(evt) {
        let newProjectId = evt.detail;
        if (newProjectId && newProjectId != project.id) {
            console.log(`ProjectPageHeader is navigating to different project...`);
            navigate(`/p/${newProjectId}`);
        }
    }

    /*let request = client.query({
        query: gql`
            query {
                me {
                    user {
                        firstName,
                        lastName,
                        id
                    },
                    companies {
                        id,
                        creationTime,
                        eyeventureUrl,
                        name,
                        websiteUrl
                    },

                }
            }
        `,
        variables: {

        }
    });*/
</script>

<header>
    <img class="project-header-background" src="/images/project-header-background.png" />
    <div class="branding">
        <a href="/dashboard" use:link>
            <Logo symbol={false} name={true} {product} type="png"/>
        </a>
        <slot name="project-logo-after"></slot>
    </div>
<!--    <div class="company-switcher">-->
<!--        <CompanyDropdown allowCreateNew={false} style="width: auto" label="" variant="shaped"/>-->
<!--    </div>-->
    {#if project}
        <div class="project-switcher">
            <ProjectDropdown fullwidth={false} selected={project.id} on:selection={viewOtherProject}/>
            <slot name="project-switcher-actions"></slot>
        </div>
    {:else}
        ...
    {/if}
    <UserMenu/>
</header>

{#await request}
    <LoadingModal />
{/await}

<style>
    header {
        display: flex;
        flex-direction: row;
        padding: 0 50px;
        position: relative;
    }

    .branding, :global(#menu-user) {
        padding-top: 25px;
        align-items: end;
        flex: 0.5;
        position: relative;
    }

    .project-header-background {
        position: absolute;
        width: 100%;
        top: -40px;
        z-index: 0;
    }

    :global(#menu-user) {
        padding: 0;
        align-items: center;
        display: flex;
    }

    :global(header .logo-wrapper img.logo) {
        max-height: 75px;
    }

    .company-switcher, .project-switcher {
        //flex: 1;
        text-align: center;
        margin-top: -20px;
        align-self: center;
        align-items: center;
        position: relative;
    }

    .project-switcher {
        display: flex;
    }
</style>